import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Dialog, DialogContent, DialogActions, Typography } from "@mui/material";
import { FUNCTION, TEXT, LIST } from "../../config/constants";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const EntityKeyNotesInstructions = ({
  isMobileView,
  showPopup,
  collapsed,
  onGotIt,
  onCollapsedCardClick,
  config,
  fiscalYear,
}) => {
  const renderContent = () => {
    if (config.contentType === TEXT) {
      return (
        <p
          style={{
            marginBottom: "0px",
            fontSize: "15px",
            fontWeight: "400",
            color: "#252D38",
            lineHeight: "1.6",
          }}
        >
          {config.content}
        </p>
      );
    }

    if (config.contentType === LIST) {
      return (
        <>
          <ol style={{ paddingLeft: "20px", margin: 0 }}>
            {config.items.map((item, index) => {
              if (typeof item === 'string') {
                return (
                  <li
                    key={index}
                    style={{
                      marginBottom: "12px",
                      fontSize: "15px",
                      fontWeight: "400",
                      color: "#252D38",
                      lineHeight: "1.6",
                    }}
                  >
                    {item}
                  </li>
                );
              }

              if (item.subItems) {
                return (
                  <li
                    key={index}
                    style={{
                      marginBottom: "12px",
                      fontSize: "15px",
                      fontWeight: "400",
                      color: "#252D38",
                      lineHeight: "1.6",
                    }}
                  >
                    {item.text}
                    {Array.isArray(item.subItems) && (
                      <ol style={{ paddingLeft: "20px", marginTop: "8px" }}>
                        {item.subItems.map((subItem, subIndex) => {
                          if (typeof subItem === 'string') {
                            return (
                              <li key={subIndex} style={{ marginBottom: "8px" }}>
                                {subItem}
                              </li>
                            );
                          }
                          if (subItem.label) {
                            return (
                              <li key={subIndex} style={{ marginBottom: "8px" }}>
                                <strong>{subItem.label}:</strong> {subItem.text}
                              </li>
                            );
                          }
                          return null;
                        })}
                      </ol>
                    )}
                  </li>
                );
              }

              return null;
            })}
          </ol>
          {config.footer && (
            <p
              style={{
                marginTop: "16px",
                marginBottom: "0px",
                fontSize: "15px",
                fontWeight: "400",
                color: "#252D38",
                lineHeight: "1.6",
              }}
            >
              {config.footer}
            </p>
          )}
        </>
      );
    }

    return null;
  };

  const getTitle = () => {
    if (typeof config.title === FUNCTION) {
      return config.title(fiscalYear);
    }
    return config.title;
  };

  const keyNotesContent = renderContent();

  return (
    <>
      {/* Mobile Dialog Popup */}
      <Dialog
        open={isMobileView && showPopup}
        onClose={() => {}}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            borderRadius: "20px",
            margin: "16px",
            maxHeight: "85vh",
          },
        }}
      >
        <DialogContent
          sx={{
            padding: "32px 24px 24px 24px",
            backgroundColor: "#FFFFFF",
          }}
        >
          <div
            style={{
              overflowY: "auto",
              overflowX: "hidden",
              maxHeight: "calc(85vh - 140px)",
              paddingRight: "8px",
            }}
          >
            <Typography
              style={{
                fontSize: "17px",
                fontWeight: "600",
                color: "#252D38",
                marginBottom: "16px",
              }}
            >
              {getTitle()}
            </Typography>
            {keyNotesContent}
          </div>
        </DialogContent>

        <DialogActions
          sx={{
            padding: "16px 24px 32px 24px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={onGotIt}
            variant="contained"
            style={{
              backgroundColor: "#0066DC",
              color: "#FFFFFF",
              borderRadius: "12px",
              padding: "12px 48px",
              fontSize: "16px",
              fontWeight: "600",
              textTransform: "none",
              minWidth: "250px",
            }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>

      {/* Web View Instructions Box */}
      <Row
        hidden={isMobileView}
        style={{ marginBottom: "12px" }}
      >
        <Col>
          <div
            style={{
              position: "relative",
              marginBottom: "12px",
            }}
          >
            <div
              className="note-container-entity"
              style={{
                position: "relative",
                height: config.contentType === 'text' ? "auto" : "220px",
                minHeight: config.contentType === 'text' ? "80px" : "220px",
                maxHeight: "220px",
                overflowY: config.contentType === 'text' ? "auto" : "scroll",
                overflowX: "hidden",
                padding: "16px",
                paddingBottom: "24px",
                backgroundColor: "#F5F7F8",
                borderRadius: "8px",
                border: "1px solid #DBE0E6",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                scrollbarWidth: "thin",
                scrollbarColor: "#888 #F5F7F8",
              }}
            >
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#252D38",
                  paddingRight: "30px",
                  marginBottom: "12px",
                  paddingLeft: "8px",
                }}
              >
                {getTitle()}
              </p>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "400",
                  lineHeight: "1.6",
                  color: "#252D38",
                  paddingLeft: config.contentType === 'text' ? "8px" : "0px",
                }}
              >
                {keyNotesContent}
              </div>
            </div>

            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "30px",
                background:
                  "linear-gradient(180deg, rgba(245, 247, 248, 0.00) 0%, #F5F7F8 100%)",
                borderRadius: "0 0 8px 8px",
                pointerEvents: "none",
                borderRight: "1px solid #DBE0E6",
                borderBottom: "1px solid #DBE0E6",
                borderLeft: "1px solid #DBE0E6",
              }}
            />
          </div>
        </Col>
      </Row>

      {/* Mobile Collapsed Card */}
      <Row
        hidden={!isMobileView || !collapsed}
        style={{ marginBottom: "12px" }}
      >
        <Col>
          <div
            onClick={onCollapsedCardClick}
            style={{
              position: "relative",
              padding: "14px 16px",
              backgroundColor: "#FFFFFF",
              borderRadius: "12px",
              border: "1px solid #DBE0E6",
              boxShadow: " 0 1px 4px 0 rgba(0, 0, 0, 0.04)",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow =
                "0 4px 8px rgba(0, 0, 0, 0.12)";
              e.currentTarget.style.borderColor = "#0D6EFD";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow =
                "0 2px 4px rgba(0, 0, 0, 0.08)";
              e.currentTarget.style.borderColor = "#DBE0E6";
            }}
          >
            <Typography
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#252D38",
                flex: 1,
              }}
            >
              {getTitle()}
            </Typography>
            <OpenInNewIcon
              sx={{
                color: "#2E3742",
                fontSize: "22px",
                marginLeft: "12px",
              }}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default EntityKeyNotesInstructions;
